import MicroApp from '@/components/micro-app';
import env from '@/env';
import { LOCATION_EMBEDDED } from '../constants';
import { tbInMyCreate } from '../goto-tb';
import history from '@/history';

function NewPandora(props: any) {
  const { data, ..._props } = props;

  return (
    <MicroApp
      data={{ ...tbInMyCreate, locationEmbedded: LOCATION_EMBEDDED, ...data, yxHistory: history }}
      destory
      name="newtfPandora1"
      {..._props}
      url={`${env.NEW_PANDORA}`}
    />
  );
}

export default NewPandora;
